// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"KnownIssuesTracker_cardHeader__2_ArN","spinner":"KnownIssuesTracker_spinner__2UeQm"};